import 'react-select/dist/react-select.css';
import { fieldPropTypes } from 'redux-form';
import PropTypes from 'prop-types';
import React from 'react';
import Select from 'react-select';
import styled from 'react-emotion';

import Input from '../../components/Form/Input';
import Style from '../../styles/common';

const Container = styled('div')`
  .Select {
    &.is-focused > .Select-control {
      box-shadow: none;
      border-color: ${Style.color.INPUT.BORDER};
    }
    
    &.is-focused.is-open > .Select-control {
      border-color: ${Style.color.INPUT.BORDER_ACTIVE};
    }
  }
  
  .Select-control {
    border: 1px solid ${Style.color.INPUT.BORDER};
    border-radius: ${Style.BORDER_RADIUS} !important;
    font-family: ${Style.FONT_FAMILY.DEFAULT};
    font-size: ${Style.FONT_SIZE.M};
    font-weight: ${Style.FONT_WEIGHT.LIGHT};
    height: 64px;
    letter-spacing: 0.25px;
    line-height: 44px;
    outline: none;
    transition: border-color 0.1s;
    
    & > *:last-child {
      padding-right: 25px;
    }
    
    .Select-clear {
      padding-right: ${Style.SPACING.XS};
    }
  }
  
  .Select-value {
    border-radius: ${Style.BORDER_RADIUS};
    line-height: 44px;
    margin-left: 8px;
    margin-top: 8px;
    padding-right: 60px !important;
    
    .Select-value-label {
      line-height: 42px;
      padding-left: 15px;
    }
    
    .Select-value-icon {
      padding: 0 12px;
    }
    
    & + .Select-input {
      padding-left: 15px !important;
    }
  }
  
  .Select-input {
    height: 64px;
    line-height: 64px;
    margin-left: 0 !important;
  }
  
  .Select-input,
  .Select-value {
    padding-right: 15px !important;
  }
  
  .Select-input,
  .Select-placeholder {
    padding-left: 1.25rem !important;
  }
  
  .Select-menu-outer {
    border-radius: ${Style.BORDER_RADIUS};
    box-shadow: ${Style.INPUT_MODAL_BOX_SHADOW};
    height: auto;
    margin-top: ${Style.MEASUREMENT.INPUT.MODAL_OFFSET};
    max-height: 290px; // Set to end half way on item so they know to scroll
    padding: ${Style.MEASUREMENT.INPUT.MODAL_PADDING};

    .Select-menu {
      max-height: 268px;
    } 
  }
  
  .Select-option {
    border-radius: ${Style.BORDER_RADIUS};
    color: ${Style.color.defaultText};
    font-family: ${Style.FONT_FAMILY.DEFAULT};
    font-size: ${Style.FONT_SIZE.M};
    font-weight: ${Style.FONT_WEIGHT.MEDIUM};
    padding: ${Style.MEASUREMENT.INPUT.MODAL_ITEM_PADDING};
    
    &.is-focused {
      background-color: ${Style.color.INPUT.HOVER};  
    }
    
    &.is-selected {
      background-color: ${Style.color.INPUT.ACTIVE};
      color: ${Style.color.INPUT.ACTIVE_TEXT};
    }
  }
  
  .Select-placeholder {
    color: ${Style.color.PLACEHOLDER};
    line-height: 64px;
  }
`;

function Dropdown(props) {
  const { input } = props;

  return (
    <Input {...props}>
      <Container>
        <Select
          joinValues={true}
          multi={true}
          onBlur={() => input.onBlur(input.value)}
          onChange={input.onChange}
          onClose={input.onBlur}
          onFocus={input.onFocus}
          options={props.options}
          placeholder={props.placeholder}
          value={input.value}
        />
      </Container>
    </Input>
  );
}

Dropdown.propTypes = {
  ...fieldPropTypes,
  label: PropTypes.string,
  placeholder: PropTypes.string,
};

Dropdown.defaultProps = {
  label: '',
  placeholder: '',
};

export default Dropdown;



// WEBPACK FOOTER //
// ./src/components/Form/Dropdown.js